// @flow
import React from 'react';
import Tooltip from '@homeaway/react-tooltip';
import {trigger as edapTrigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import exclusivityIcon from './icons/exclusivity-icon.svg';
import {EXCLUSIVITY} from '../../constants/badges';
import classNames from 'classnames';

type Props = {
    label: string,
    parentNode?: ?HTMLBodyElement,
    toolTipText?: string,
    id?: string
};

const triggerEdap = (label: string, id?: string) => {
    edapTrigger(GENERIC_EVENT, {
        eventaction: `Hit badge hover: ${id ? id : label}`,
        highfrequency: 'true'
    });
};

const LabelText = ({label, id = ''}) => (
    <span
        role="presentation"
        className={classNames('HitInfo__labels_item label label--serp', {
            [`label-${id}`]: !!id
        })}
        onMouseEnter={() => triggerEdap(label, id)}
    >
        {id === EXCLUSIVITY && <img src={exclusivityIcon()} alt={label} />}
        {label}
    </span>
);

const HitLabel = ({label, toolTipText, parentNode, id}: Props) => {
    if (toolTipText) {
        return (
            <Tooltip
                tooltipType="popover"
                placement="top"
                content={toolTipText}
                parentNode={parentNode}
            >
                <LabelText label={label} id={id} />
            </Tooltip>
        );
    }
    return <LabelText label={label} id={id} />;
};

export default HitLabel;
